import ImagePreviewModel from "crop-image/src/ImagePreviewModel";
import VoiceFileResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/VoiceFileResponse";
import AffirmationUpdateRequest from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationUpdateRequest";
import { mapToCropRequest } from "@/frameworks/imagePreviewModelMapper";
import AffirmationGetDetailResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/AfirmationSerivce/AffirmationGetDetailResponse";
import AudioGroupViewModel from "@models/meditations/create/audioGroupViewModel";
import MeditationAudioViewModel from "@models/meditations/create/meditationAudioViewModel";
import AffirmationTranslateModel from "./affirmationTranslateModel";

export default class CreateAffirmationViewModel {
	id?: number = 0;
	isPaid: boolean = false;
	useBackgroundMusic: boolean = true;
	animationId: string = null;
	animationUrl: string = '';
	audios: Array<AudioGroupViewModel> = [];
	translations: Array<AffirmationTranslateModel> = null;
	iconImage: ImagePreviewModel = new ImagePreviewModel();
	coverImage: ImagePreviewModel = new ImagePreviewModel();
	backgroundImage: ImagePreviewModel = new ImagePreviewModel();
	initLanguages(languages: string[]) {
		this.translations = languages.map(
			(x) =>
			  new AffirmationTranslateModel({
				langCode: x,
			  })
		  );
	}
	private hasAudioContent(audio: MeditationAudioViewModel): boolean {
		return !!(audio && (audio.id || audio.base64File || audio.audioFile || audio.audioUrl));
	}
	toServerModel(
		includeVoiceFiles: boolean = true,
		includeTranslations: boolean = true
	): AffirmationUpdateRequest {
		const translations = includeTranslations
			? this.translations.filter((translation) => {
				if (translation.hasContent()) {
					return true;
				}

				return this.audios.some((audioGroup) =>
					(audioGroup.audios || []).some((audio) =>
						audio.langCode === translation.langCode &&
						this.hasAudioContent(audio)
					)
				);
			})
			: [];

		const req = new AffirmationUpdateRequest({
			Id: this.id || 0,
			IsPaid: this.isPaid,
			UseBackgroundMusic: this.useBackgroundMusic,
			AnimationId: this.animationId,
			Back: mapToCropRequest(this.backgroundImage), // this.coverImage,
			Cover: mapToCropRequest(this.coverImage), // this.coverImage,
			Icon: mapToCropRequest(this.iconImage), // this.iconImage,
			Translations: translations.map((x) => x.toServerModel())
		});
		if (!includeTranslations) {
			return req;
		}
		return req;
	}
	fromServerModel(model: AffirmationGetDetailResponse) {
		this.id = model.Id;
		this.isPaid = model.IsPaid;
		this.useBackgroundMusic = model.UseBackgroundMusic;
		this.animationId = model.AnimationId;

		const serverTranslations = model.Translations || [];
		const langs = this.translations.map(x => x.langCode);
		this.translations.forEach(tr => {
			const serverTranslation = serverTranslations.find(x=>x.LangCode == tr.langCode);
			if (serverTranslation != null) {
				tr.fromServerModel(serverTranslation);
			}
		});
		const counts = serverTranslations.map(x=>(x.VoiceFiles || []).length || 0);
		const audioCount = counts.length > 0 ? Math.max(...counts) : 0;
		this.backgroundImage.ImageUrl = model.BackUrl;
		this.coverImage.ImageUrl = model.CoverUrl;
		this.iconImage.ImageUrl = model.IconUrl;
		this.audios = Array(audioCount).fill(0).map(x=> new AudioGroupViewModel(langs));
		this.audios.forEach((audioGroup, i) => {
			audioGroup.audios = [];
			const audios = this.translations.map(x=>{
					const voiceFiles = ((serverTranslations.find(mt => mt.LangCode == x.langCode) || {}).VoiceFiles || [])
					return {
						langCode: x.langCode,
						file: ((voiceFiles || [])[i] || new VoiceFileResponse({Url: null}))
				}
			});
			if (audios != null && audios.length > 0) {
				audioGroup.audios = audios.map(x=> new MeditationAudioViewModel({
					id: x.file.Id,
					langCode: x.langCode,
					name: x.file.Name,
					description: x.file.Description,
					isPaid: x.file.IsPaid,
					audioUrl: x.file.Url,
					femaleUrl: x.file.FemaleUrl,
					maleUrl: x.file.MaleUrl
				}));
			}
		});
	}
}
